/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeMessagePushPreferenceDto,
  ApiEnvelopePushConfigDto,
  ApiEnvelopePushSubscribeResult,
  ApiEnvelopePushTestResult,
  MessagePushPreferenceDto,
  PushSubscribeRequest,
  PushUnsubscribeRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type pushGetConfigResponse200 = {
  data: ApiEnvelopePushConfigDto
  status: 200
}

export type pushGetConfigResponse401 = {
  data: ApiEnvelopePushConfigDto
  status: 401
}

export type pushGetConfigResponseSuccess = (pushGetConfigResponse200) & {
  headers: Headers;
};
export type pushGetConfigResponseError = (pushGetConfigResponse401) & {
  headers: Headers;
};

export type pushGetConfigResponse = (pushGetConfigResponseSuccess | pushGetConfigResponseError)

export const getPushGetConfigUrl = () => {




  return `/api/push/config`
}

export const usePushGetConfigHook = (): ( options?: RequestInit) => Promise<pushGetConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getPushGetConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type pushSubscribeResponse200 = {
  data: ApiEnvelopePushSubscribeResult
  status: 200
}

export type pushSubscribeResponse401 = {
  data: ApiEnvelopePushSubscribeResult
  status: 401
}

export type pushSubscribeResponseSuccess = (pushSubscribeResponse200) & {
  headers: Headers;
};
export type pushSubscribeResponseError = (pushSubscribeResponse401) & {
  headers: Headers;
};

export type pushSubscribeResponse = (pushSubscribeResponseSuccess | pushSubscribeResponseError)

export const getPushSubscribeUrl = () => {




  return `/api/push/subscribe`
}

export const usePushSubscribeHook = (): (pushSubscribeRequest?: PushSubscribeRequest, options?: RequestInit) => Promise<pushSubscribeResponse> => {

      const customFetcher = useSfetchMutator();
      return (pushSubscribeRequest?: PushSubscribeRequest, options?: RequestInit) => {

        return customFetcher(getPushSubscribeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pushSubscribeRequest)
  }
);
      }
  }


export type pushUnsubscribeResponse200 = {
  data: ApiEnvelopePushSubscribeResult
  status: 200
}

export type pushUnsubscribeResponse401 = {
  data: ApiEnvelopePushSubscribeResult
  status: 401
}

export type pushUnsubscribeResponseSuccess = (pushUnsubscribeResponse200) & {
  headers: Headers;
};
export type pushUnsubscribeResponseError = (pushUnsubscribeResponse401) & {
  headers: Headers;
};

export type pushUnsubscribeResponse = (pushUnsubscribeResponseSuccess | pushUnsubscribeResponseError)

export const getPushUnsubscribeUrl = () => {




  return `/api/push/unsubscribe`
}

export const usePushUnsubscribeHook = (): (pushUnsubscribeRequest?: PushUnsubscribeRequest, options?: RequestInit) => Promise<pushUnsubscribeResponse> => {

      const customFetcher = useSfetchMutator();
      return (pushUnsubscribeRequest?: PushUnsubscribeRequest, options?: RequestInit) => {

        return customFetcher(getPushUnsubscribeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pushUnsubscribeRequest)
  }
);
      }
  }


export type pushGetPreferencesResponse200 = {
  data: ApiEnvelopeMessagePushPreferenceDto
  status: 200
}

export type pushGetPreferencesResponse401 = {
  data: ApiEnvelopeMessagePushPreferenceDto
  status: 401
}

export type pushGetPreferencesResponseSuccess = (pushGetPreferencesResponse200) & {
  headers: Headers;
};
export type pushGetPreferencesResponseError = (pushGetPreferencesResponse401) & {
  headers: Headers;
};

export type pushGetPreferencesResponse = (pushGetPreferencesResponseSuccess | pushGetPreferencesResponseError)

export const getPushGetPreferencesUrl = () => {




  return `/api/push/preferences`
}

export const usePushGetPreferencesHook = (): ( options?: RequestInit) => Promise<pushGetPreferencesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getPushGetPreferencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type pushSetPreferencesResponse200 = {
  data: ApiEnvelopeMessagePushPreferenceDto
  status: 200
}

export type pushSetPreferencesResponse401 = {
  data: ApiEnvelopeMessagePushPreferenceDto
  status: 401
}

export type pushSetPreferencesResponseSuccess = (pushSetPreferencesResponse200) & {
  headers: Headers;
};
export type pushSetPreferencesResponseError = (pushSetPreferencesResponse401) & {
  headers: Headers;
};

export type pushSetPreferencesResponse = (pushSetPreferencesResponseSuccess | pushSetPreferencesResponseError)

export const getPushSetPreferencesUrl = () => {




  return `/api/push/preferences`
}

export const usePushSetPreferencesHook = (): (messagePushPreferenceDto?: MessagePushPreferenceDto, options?: RequestInit) => Promise<pushSetPreferencesResponse> => {

      const customFetcher = useSfetchMutator();
      return (messagePushPreferenceDto?: MessagePushPreferenceDto, options?: RequestInit) => {

        return customFetcher(getPushSetPreferencesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagePushPreferenceDto)
  }
);
      }
  }


export type pushSendTestResponse200 = {
  data: ApiEnvelopePushTestResult
  status: 200
}

export type pushSendTestResponse401 = {
  data: ApiEnvelopePushTestResult
  status: 401
}

export type pushSendTestResponseSuccess = (pushSendTestResponse200) & {
  headers: Headers;
};
export type pushSendTestResponseError = (pushSendTestResponse401) & {
  headers: Headers;
};

export type pushSendTestResponse = (pushSendTestResponseSuccess | pushSendTestResponseError)

export const getPushSendTestUrl = () => {




  return `/api/push/test`
}

export const usePushSendTestHook = (): ( options?: RequestInit) => Promise<pushSendTestResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getPushSendTestUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


